import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSecuritySettings as UpdateSecuritySettingsMutation,
    UpdateSecuritySettingsVariables as UpdateSecuritySettingsVariables,
    SecurityUpdateSettingsInput,
} from 'nutshell-graphql-types';

import UPDATE_SECURITY_SETTINGS from '../mutations/update-security-settings.graphql';

export const useUpdateSecuritySettings = (): {
    updateSecuritySettings: (arg1: SecurityUpdateSettingsInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSecuritySettings, {loading, error}] = useMutation<
        UpdateSecuritySettingsMutation,
        UpdateSecuritySettingsVariables
    >(UPDATE_SECURITY_SETTINGS);

    return {
        updateSecuritySettings: (input: SecurityUpdateSettingsInput) =>
            updateSecuritySettings({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
